import { Component, OnInit, Input } from '@angular/core';
import { ResidentialService } from '../../residential.service';
import { ViewChild, ElementRef, NgZone } from '@angular/core';
import { _ } from 'underscore';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import {NgbModal, NgbActiveModal, NgbModule, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { Router, NavigationEnd } from '@angular/router';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';

@Component({
  selector: 'app-r-q1',
  templateUrl: './r-q1.component.html',
  styleUrls: ['./r-q1.component.css', '../residential-question.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({ transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' }))
      ])
    ])
  ]
})

export class RQ1Component implements OnInit {

  @Input() data: any;
  firstname: String;
  questions = [];
  userResponses = [];
  question;
  questionObj;
  index;
  disablebutton = false;
  showbutton = true;
  deviceWidth;
  timer;
  modalRef: BsModalRef;
  q1; q2;
  showComponent = true;
  @ViewChild('template', { static: true }) template: ElementRef;
  ngbModalOptions: NgbModalOptions = {
    backdrop : 'static',
    keyboard : false
  };

  constructor(private residentialService: ResidentialService, private modalService: BsModalService,    private route: Router) {
    this.questions = this.residentialService.getQues();
    this.deviceWidth = this.residentialService.deviceWidth;
    this.userResponses = this.residentialService.userResponse.userResponses;
    localStorage.removeItem('userName');
    
  }

  ngOnInit() {
    this.residentialService.currentId = this.data;

   
    // To check the flow is from another address and renewal - If add another address and renewal flow quit this question
    // To get the accountId from url
    const url = window.location.href;
    const urlArr = url.split('/');
    if (urlArr && urlArr.length !== 0 && urlArr[4] === 'residentialQues' && (urlArr[5] === 'add-address')) {
      this.residentialService.messageService({ 'currentId': this.data });
      this.showComponent = false;
    }

    // check the flow is renewal
    if (this.residentialService.questionFlowType === 'renewal') {
      this.residentialService.messageService({ 'nextId': '0014' });
      this.showComponent = false;
    }

    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].res_question;
        this.questionObj = this.questions[i];
        this.index = i;
      }
    }
    if (this.deviceWidth > 768) {
      this.q1 = this.question.split(' Enter');
      this.q2 = 'Enter' + this.q1[1];
      this.q1 = this.q1[0];
    }
    if (this.userResponses != null && this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'res_question_id': this.questionObj._id });
      if (!_.isEmpty(obj)) {
        this.firstname = obj.fieldValue;
          this.disablebutton = true;
        if (this.deviceWidth < 768) {
          this.getFirstname();
        }
      }
    }
    const userObj = JSON.parse(sessionStorage.getItem('userObj'));
    if (!_.isEmpty(userObj)) {
      this.firstname = userObj['fName'] + " " + userObj['lName']
        ? this.titleCase(userObj['fName'] + " " + userObj['lName'])
        : '';
        //if(this.userResponses.length != 0)
        //{
          this.getFirstname();

        //}

    }

    if(!this.disablebutton)
    {
     this.showbutton = false;
    }

  }

  onKeyPress(e)
  {
      if(e.which === 13){
        this.getFirstname();
       } 

  }

  removeURLParameter(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');   
    if (urlparts.length >= 2) {

        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i = pars.length; i-- > 0;) {    
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {  
                pars.splice(i, 1);
            }
        }

        return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
    }
    return url;
}

  titleCase(str) {
    str = str.toLowerCase().split(' ');
    for (let i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(' ');
}

  getFirstname() {
    if (_.isEmpty(this.firstname) &&  this.firstname != "") {
      // alert('Please Fill the Name.');
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({'currentId': this.data});
      }
    } else {
      const Obj = {
        'res_question_id': this.data,
        'fieldName': 'first_name',
        'fieldValue': this.titleCase(this.firstname)
      };

      // Set the username to show in recommendation page
      // To get the user name from questionarie
      localStorage.setItem('userName', this.firstname.toString());
      const isWhitespace = (this.firstname || '').trim().length === 0;
      const isValid = !isWhitespace;
    
      if(isValid === true && this.firstname != "" && this.firstname.length > 0){
        this.disablebutton = true;
        this.residentialService.updateResponses(Obj);
        this.residentialService.messageService({ 'currentId': this.data });
      }else{
        this.disablebutton = false;
      }
      clearTimeout(this.timer);
      if (this.deviceWidth < 768) {
        this.timer = setTimeout(() => {
          this.residentialService.messageService({ 'currentId': this.data });
        }, 1000);
      } else {
        //this.residentialService.messageService({ 'currentId': this.data });
      }
    }
  }

  enableButton(event) {
      const isWhitespace = (this.firstname || '').trim().length === 0;
      const isValid = !isWhitespace;
    if (_.isEmpty(this.firstname) && this.firstname != "" && isValid === true) {
      this.disablebutton = false;
    }else if(isValid === false){
      this.disablebutton = false;
    } else {
      this.disablebutton = true;
    }
  }

  
  openModal(template: ElementRef<any>) {


    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-small'} , this.ngbModalOptions)
    );
  }

 closeModalWithOutContact() {
    

    this.modalRef.hide();

  
    
  }

  Redirect(value){

  if(value =="Ques")
  {
    this.closeModalWithOutContact();
    this.route.navigateByUrl('/residentialQues');
  }

  }

}

